import { render } from "./PersonalInformationPage.vue?vue&type=template&id=49f30422&scoped=true"
import script from "./PersonalInformationPage.vue?vue&type=script&lang=js"
export * from "./PersonalInformationPage.vue?vue&type=script&lang=js"

import "./PersonalInformationPage.vue?vue&type=style&index=0&id=49f30422&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f30422"]])

export default __exports__